module.exports = __webpack_public_path__ + "img/596eb2bbb6d5414f97b36f7c5fe9d0ca-640.75544607.jpg";